import { getVersesForChapter } from './bibleData';

// Converts either plan type into a common ordered sequence of
// {book, chapter, startVerse, endVerse} items, so playback/navigation code
// can treat a Reading Plan and a Passages Plan identically once resolved.
//
// Reading Plans (`plan.chapters`) are whole-chapter entries — each is
// expanded to its full verse range. Passages Plans (`plan.passages`) are
// already verse-range items and pass through unchanged.
export function getPlanSequence(plan) {
  if (!plan) return [];
  if (Array.isArray(plan.passages)) {
    return plan.passages;
  }
  if (Array.isArray(plan.chapters)) {
    return plan.chapters.map((c) => {
      const verses = getVersesForChapter(c.book, c.chapter);
      return {
        book: c.book,
        chapter: c.chapter,
        startVerse: 1,
        endVerse: verses.length ? verses[verses.length - 1] : 1,
      };
    });
  }
  return [];
}

// Finds where {book, chapter, verse} currently sits within a resolved
// sequence — used by next/prev navigation to know "where am I in the plan."
// Falls back to a book/chapter-only match if no item's verse range contains
// the given verse (e.g. mid-transition, or verse omitted).
export function findSequenceIndex(sequence, book, chapter, verse) {
  if (verse != null) {
    const exact = sequence.findIndex((item) =>
      item.book === book && item.chapter === chapter &&
      verse >= item.startVerse && verse <= item.endVerse
    );
    if (exact !== -1) return exact;
  }
  return sequence.findIndex((item) => item.book === book && item.chapter === chapter);
}
